"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseJSON = exports.rejectHTTPErrors = exports.networker = void 0;
var networker_1 = require("@idp/networker");
var networker = new networker_1.Networker();
exports.networker = networker;
var loginPageUrl = "https://www.att.com/my/#/login";
function rejectHTTPErrors(res) {
    if (res.status === 401) {
        window.location.href = loginPageUrl;
        return Promise.reject(res);
    }
    else if (res.status > 401) {
        return Promise.reject(res);
    }
    else {
        return Promise.resolve(res);
    }
}
exports.rejectHTTPErrors = rejectHTTPErrors;
function parseJSON(res) {
    return res.json();
}
exports.parseJSON = parseJSON;
//# sourceMappingURL=Networker.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/services/Networker.js
// module id = 1194
// module chunks = 8